import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import PermanentMedicationCreate from './PermanentMedicationCreate';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	onCreate: () => void;
	patientId: string;
}

const PermanentMedicationCreateModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.permanentMedicationCreate.modalTitle'
			size={Size.LG}
			{...props}>
			<PermanentMedicationCreate
				onCreate={props.onCreate}
				patientId={props.patientId}
			/>
		</BaseModal>
	);
};

export default PermanentMedicationCreateModal;
